import { ArrowUpRight, BadgeDollarSign } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function FeaturedListings({ listings, cityName = "" }) {
  if (!listings?.length) return null;
  return (
    <div data-testid="featured-listings">
      <p className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-brand-terracotta font-semibold">
        <BadgeDollarSign className="h-4 w-4" /> Frank's featured listings — updated daily from yourrealtorfrank.com
      </p>
      <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {listings.slice(0, 6).map((l, i) => (
          <a
            key={l.url}
            data-testid={`listing-card-${i}`}
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group overflow-hidden rounded-2xl border border-brand-border-sand bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
          >
            <div className="relative h-44 overflow-hidden bg-brand-sand-dark">
              {l.image && (
                <img
                  src={l.image?.startsWith("/") ? `${API_BASE}${l.image}` : l.image}
                  alt={`${l.address}, ${l.location}`}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              )}
              <span className="absolute left-3 top-3 rounded-full bg-brand-navy-dark/90 px-3 py-1 text-sm font-bold text-brand-gold">
                {l.price}
              </span>
            </div>
            <div className="p-5">
              <p className="font-display text-lg font-bold leading-snug text-brand-navy-dark group-hover:text-brand-red transition-colors">{l.address}</p>
              <p className="mt-0.5 text-sm text-brand-slate">{l.location}</p>
              <div className="mt-3 flex items-center justify-between">
                <p className="text-xs font-semibold text-brand-slate/80">{l.specs.join(" · ")}</p>
                <ArrowUpRight className="h-4 w-4 text-brand-slate/40 transition-colors group-hover:text-brand-red" />
              </div>
            </div>
          </a>
        ))}
      </div>
      <p className="mt-4 text-xs text-brand-slate/70">
        Listings sync every morning from{" "}
        <a href="https://yourrealtorfrank.com" target="_blank" rel="noopener noreferrer" className="font-bold text-brand-navy hover:text-brand-red transition-colors">yourrealtorfrank.com</a>
        {cityName ? ` — call Frank at (520) 336-7614 about any ${cityName}-area home.` : "."}
      </p>
    </div>
  );
}
